'use client'

import ViewIntersection from '@app/components/analytics/view-intersection/view-intersection'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {ReactNode} from 'react'

type Props = {
  event: string
  className: string
  children: ReactNode
  additionalAttributes?: Record<string, string | number | boolean>
}

const SearchSectionAnalyticsWrapper = ({event, className, children, additionalAttributes}: Props) => {
  return (
    <ViewIntersection onVisible={() => triggerAnalytics(event, additionalAttributes).sendAll()} className={className}>
      {children}
    </ViewIntersection>
  )
}

export default SearchSectionAnalyticsWrapper
